import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {

  isAlertTrigger = new Subject<boolean>();

  constructor() { }
}
